import React from "react";
import "../../Components/NavBar/NavBar.css";
import "../../Pages/Responsive.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import SignUpAndLogin from "../SignUpAndLogin/SignUpAndLogin";
import SocialHeadings from "../SocialHeadings";
import { FaLinkedin } from "react-icons/fa";
import { FiAlignJustify } from "react-icons/fi";
import {
  Facebook,
  Instagram,
  MailOutline,
  PhoneAndroidOutlined,
  Twitter,
  WhatsApp,
} from "@material-ui/icons";

function NavBarRes() {
  return (
    <div className="">
      {["lg"].map((expand) => (
        <Navbar key={expand} expand={expand} className="mb-3">
          <Container>
            {/* <Navbar.Brand href="#"></Navbar.Brand> */}

            {/* <Navbar.Toggle bg="transparent" expand="lg" variant="light"
            
            />  */}
            <Navbar.Toggle
              aria-controls="offcanvasNavbar"
              className="ToggleImge"
            >
              <FiAlignJustify
                aria-controls="offcanvasNavbar"
                className="ResponsiveIcon"
              />
            </Navbar.Toggle>

            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title
                  id={`offcanvasNavbarLabel-expand-${expand}`}
                ></Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body>
                {/* <SocialHeadings /> */}

                <div>
                  <div className="IconContainer">
                    <a
                      href="https://www.facebook.com/profile.php?id=100092700216336"
                      className="ClickLink2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Facebook className="MediaIcon facebook" />
                    </a>

                    <a
                      href=" https://www.linkedin.com/groups/13021030"
                      className="ClickLink2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin className="MediaIcon twitter" />
                    </a>

                    <a
                      href="https://www.instagram.com/unilagalumniuk?igsh=ZHA1ZXR0dm9oa3dz&utm_source=qr"
                      className="ClickLink2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Instagram className="MediaIcon Instagram" />
                    </a>
                  </div>
                </div>

                <div className="InfoDisplay3003">
                  <div className="InfoDisplay">
                    <div>
                      <MailOutline />{" "}
                    </div>
                    <div className="EmailGap">info@unilagalumniuk.org</div>
                  </div>
                  <div className="InfoDisplay">
                    <div>
                      <PhoneAndroidOutlined />
                    </div>
                    <div>+447592893361</div>
                  </div>
                </div>
                <br />
                <br />

                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <div className="DrawerList">
                    <Link to="/" className="DrawNavigation">
                      <div className="DrawNav">Home</div>
                    </Link>

                    <Link to="/Membership" className="DrawNavigation">
                      <div className="DrawNav">Membership</div>
                    </Link>

                    <Link to="/Excos" className="DrawNavigation">
                      <div className="DrawNav">Excos</div>
                    </Link>
                    <Link to="/Projects" className=" DrawNavigation">
                      <div className="DrawNav">Projects</div>
                    </Link>
                    <Link to="/News" className="DrawNavigation">
                      <div className="DrawNav">News</div>
                    </Link>
                    <Link to="/Events" className="DrawNavigation">
                      <div className="DrawNav">Events</div>
                    </Link>
                    <Link to="/AboutUs" className="DrawNavigation">
                      <div className="DrawNav"> About us</div>
                    </Link>
                    <Link to="/Gallery" className="DrawNavigation">
                      <div className="DrawNav"> Photo Gallery</div>
                    </Link>

                    <div className=" DrawNavigation">
                      <a
                        href="https://www.unilagalumniassociation.org"
                        className="DrawNav"
                      >
                        Visit Our National Body
                      </a>
                    </div>
                  </div>
                </Nav>
                {/* <SignUpAndLogin /> */}
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </div>
  );
}

export default NavBarRes;
